<div class="input-group mb-4">
  <div class="input-group-prepend">
    <span class="input-group-text"><i class="bi bi-search"></i></span>
  </div>
  <input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="searchRequest.query" (keyup)="querySearch()"/>
</div>

<div class="border-bottom"></div>
  
<search-paging [searchComponent]="this"></search-paging>

<div class="results" *ngIf="results">
  <table class="table table-hover">
    <tbody>
      <tr *ngFor="let supplier of results.content">
        <td 
          (click)="selectSupplier(supplier)"
          [class.bg-info]="selectedSupplier && selectedSupplier.id == supplier.id"
          >{{ supplier.name }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<search-paging [searchComponent]="this"></search-paging>